import { React } from "react";
import { Outlet } from "react-router-dom";

const Bethlehem = () => {
	return (
		<div className="bethlehem__container">
			<div className="bethlehem__header">
				<h1 className="bethlehem__header__title">
					베들레헴 메뉴 개수 관리
				</h1>
			</div>
			<Outlet />
		</div>
	);
};

export default Bethlehem;
